import { axios } from '../config/axios';

const endPoint = '/project/question';

const getById = (questionId) => {
    return axios.get(`${endPoint}/${questionId}`);
}

const listByConfigurationId = (body) => {
    return axios.post(`${endPoint}/list-by-configuration-id`, body);
}

const getForPreview = (configurationId, language, setNumber, questionNo, imageSize, verifyQuestionNo = null) => {
    return axios.post(`${endPoint}/for-preview`, {
        configurationId,
        language,
        setNumber,
        questionNo,
        imageSize,
        verifyQuestionNo,
    });
}

const verifyQuestion = (questionId, userId) => {
    return axios.post(`${endPoint}/verify-question/${questionId}`, {
        userId: userId,
    });
}

const verifyQuestionsByConfigurationId = (body) => {
    return axios.post(`${endPoint}/verify-questions-by-configuration-id`, body);
}

const updateById = (questionId, body) => {
    return axios.post(`${endPoint}/${questionId}`, body);
}

const upsertTypingQuestion = (body) => {
    return axios.post(`${endPoint}/upsert-typing-question`, body);
}

const descriptiveUpload = (body) => {
    return axios.post(`${endPoint}/descriptive-upload`, body);
}

const setWiseUpload = (body) => {
    return axios.post(`${endPoint}/set-wise-upload`, body);
}

const zipUpload = (body) => {
    return axios.post(`${endPoint}/zip-upload`, body);
}

const bulkUpload = (body) => {
    return axios.post(`${endPoint}/bulk-upload`, body);
}

const deleteAllBySet = (body) => {
    return axios.post(`${endPoint}/delete-all-by-set`, body);
}

const deleteAll = (body) => {
    return axios.post(`${endPoint}/delete-all`, body);
}

const downloadContentTemplate = () => {
    return axios.get(`${endPoint}/download-content-template`, {
        responseType: 'blob',
    });
}

const downloadDescriptiveContentTemplate = () => {
    return axios.get(`${endPoint}/download-descriptive-template`, {
        responseType: 'blob',
    });
}

const getPendingVerificationQuestionNumber = (body) => {
    return axios.post(`${endPoint}/pending-verification-question-number`, body);
}

const downloadQuestionTemplate = (projectMasterId) => {
    return axios.get(`${endPoint}/download-question-template/${projectMasterId}`, {
        responseType: 'blob',
    });
}

const updateAnswerKeys = (formData) => {
    return axios.put(`${endPoint}/update-answer-key`, formData);
}

export {
    getById,
    listByConfigurationId,
    getForPreview,
    descriptiveUpload,
    setWiseUpload,
    zipUpload,
    verifyQuestion,
    upsertTypingQuestion,
    verifyQuestionsByConfigurationId,
    updateById,
    deleteAllBySet,
    downloadContentTemplate,
    downloadDescriptiveContentTemplate,
    getPendingVerificationQuestionNumber,
    bulkUpload,
    deleteAll,
    downloadQuestionTemplate,
    updateAnswerKeys,
}